import { ACTION_TYPE } from "../actions/masterLangAction";

const initState = {
  masterLang: [],
  factUpdate: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case ACTION_TYPE.SET_MASTER_LANG:
      return {
        ...state,
        masterLang: action.payload,
      };
    case ACTION_TYPE.SET_FACT_UPDATE:
      return {
        ...state,
        factUpdate: action.payload,
      };
    default:
      return state;
  }
};
